import { render, staticRenderFns } from "./ZensocialLanding.vue?vue&type=template&id=75136a4d"
import script from "./ZensocialLanding.vue?vue&type=script&lang=js"
export * from "./ZensocialLanding.vue?vue&type=script&lang=js"
import style0 from "./ZensocialLanding.vue?vue&type=style&index=0&id=75136a4d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports